import { withInstall } from '@meng-ui-vue/utils'
import DatavLoading from './src/datav-loading.vue'

export const MxDatavLoading = withInstall(DatavLoading)
export default MxDatavLoading

export * from './src/datav-loading'
export type { DatavLoadingInstance } from './src/instance'
